<template>
    <div class="wrapper-box">
        <div v-if="!error" class="result-box">
            <div class="ticket-image-box">
                <div class="icon-container">
                    <b-icon
                        icon="far fa-ticket-alt"
                        class="ticket-icon"
                        size="is-small"
                        style="color: var(ticket?.event?..backgroundColor)"
                    ></b-icon>
                </div>
                <nuxt-img
                    v-if="ticket?.event?.image && eventImage"
                    loading="lazy"
                    :src="eventImage"
                    alt="event image"
                    class="event-img"
                />
            </div>

            <div class="info-box" :class="mobile ? 'pt-5' : 'pb-3'">
                <div class="result">
                    <nuxt-link
                        class="inline-link is-subtle has-text-weight-bold mb-3"
                        :to="localePath(`/event/${ticket?.event?.id}`)"
                    >
                        <div>
                            <div class="title_field is-primary-alt mb-1">
                                {{ ticket?.event?.title }}
                            </div>
                            <div
                                class="is-size-6 is-uppercase has-text-weight-bold"
                            >
                                {{
                                    this.$i18n.locale === "it"
                                        ? ticket?.event?.category?.name
                                        : ticket?.event?.category?.nameEn
                                }}
                            </div>
                        </div>

                        <b-icon icon="fas fa-chevron-right" size="is-small" />
                    </nuxt-link>
                </div>
                <!-- <add-to-cal-button
                    id="add-to-cal-button"
                    name="Title"
                    options="'Apple','Google'"
                    location="World Wide Web"
                    startDate="2023-09-11"
                    endDate="2023-09-11"
                    startTime="10:15"
                    endTime="23:30"
                    timeZone="America/Los_Angeles"
                    description="Event description"
                    url="https://www.example.com"
                ></add-to-cal-button> -->
                <div class="result">
                    <div class="date_field">
                        {{
                            new Date(ticket?.event?.start).toLocaleDateString(
                                this.$i18n.locale,
                                {
                                    weekday: "long",
                                    // no year
                                    year: undefined,
                                    month: "short",
                                    day: "numeric",
                                }
                            )
                        }}
                        H{{
                            new Date(ticket?.event?.start).toLocaleTimeString(
                                this.$i18n.locale,
                                {
                                    hour: "numeric",
                                    minute: "numeric",
                                }
                            )
                        }}
                    </div>
                </div>
            </div>
            <b-collapse
                class="card-collapse"
                v-if="mobile === true && ticket?.id"
                animation="slide"
                aria-id="contentIdForA11y3"
                :open.sync="open"
            >
                <template #trigger="{ open }">
                    <div
                        class="card-collapse-header"
                        role="button"
                        aria-controls="contentIdForA11y3"
                        :aria-expanded="open"
                    >
                        <p
                            class="is-size-4 m-0 has-text-weight-bold is-primary-alt card-collapse-header-title"
                        >
                            <!-- <b-icon icon="fas fa-qrcode" size="is-small" /> -->
                            {{
                                open
                                    ? $t("profile.memberships.hideQR")
                                    : $t("profile.memberships.showQR")
                            }}
                        </p>
                        <a class="card-collapse-header-icon">
                            <b-icon
                                :icon="
                                    open
                                        ? 'fas fa-chevron-up'
                                        : 'fas fa-chevron-down'
                                "
                            >
                            </b-icon>
                        </a>
                    </div>
                </template>
                <div
                    class="hero-qrcode"
                    v-if="new Date(ticket?.event?.end) > new Date()"
                >
                    <qrcode-vue
                        id="qrcode"
                        v-if="ticket?.id"
                        :value="ticket?.id"
                        level="H"
                        foreground="rgb(110, 102, 224)"
                        background="#ffffff"
                        render-as="svg"
                        :size="this.size"
                    />
                </div>
            </b-collapse>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.date_field {
    font-size: 1rem !important;
    font-weight: 700 !important;
    color: var(--color-subtle) !important;
    text-transform: uppercase !important;
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.flex-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 0;
}
.inline-link {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 0;
}
.title_field {
    font-size: 1.5rem;
    font-weight: 700 !important;
    color: var(--color-subtle);
    text-transform: uppercase;
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.card-collapse {
    .card-collapse-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 1rem;
        margin-bottom: 0;
    }
    width: 100%;
    background: var(--bg);
    border-radius: 1rem;
    // margin-top: 1rem;
}
.wrapper-box {
    // border: 1px solid var(--color-danger);
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.submit-btn {
    background: rgba(var(--bg-rgba), 0.3) !important;
    width: 100%;
    min-width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem 0 1.5rem;
    margin: 1rem 0 0 0 !important;
    align-items: center;
    .icon {
        font-size: 2rem !important;
    }
}
.error_field {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-danger);
    /* margin-bottom: 0.35rem; */
}
.info-box {
    padding: 1rem 1rem 0 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.ticket-image-box {
    position: relative;
    width: 100%;
    .icon-container {
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        border-radius: 50%;
        background: var(--bg-secondary);
        padding: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        aspect-ratio: 1/1;
        .ticket-icon {
            color: var(--color-subtle);
            transform: rotate(-15deg);
            // top: 1rem;
            // left: 1rem;
        }
    }
}
.event-img {
    max-height: 100px;
    width: 100%;
    object-fit: cover;
}

.result-box {
    /* width: 100%; */
    /* height: 100%; */
    // margin-top: 1rem;
    // width: calc(100vw - 2rem);
    // margin-top: 1rem;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    overflow: hidden;
    background: var(--bg);
    // padding: 2rem;
    border-radius: 1rem;
    &.is-errored {
        background: rgba(var(--color-danger-rgba), 0.35) 0%;
    }
}
.result_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-primary-alt);
    text-transform: capitalize;
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}

.query_field {
    font-size: 1.35rem;
    margin-bottom: 0.5rem;
    font-weight: 700 !important;
    color: var(--color-primary-alt);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.success_field {
    font-size: 1.25rem;
    font-weight: 700 !important;
    // color: var(--color-primary);
    color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.result {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 1.25rem;
}
.hero-qrcode {
    animation: appear 0.5s ease-in-out;
    width: 100%;
    height: 100%;

    // min-height: 300px
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#qrcode {
    // overflow: hidden;
    padding: 2rem;
    background: white;
    border-radius: 1rem;
    // max-width: 300px !important;
    width: 100%;
    // max-width: 350px;

    // min-width: 90vw !important;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    max-height: 80vw;

    // max-width: 80vw;
    @media (min-width: 560px) {
        // max-width: 320px;
        max-height: 320px;
        // min-width: 300px !important;
        // min-height: 300px;
    }
    object-fit: contain;

    // border: 1px solid red;
}
</style>
<script>
// import { atcb_init, atcb_destroy, atcb_action } from "add-to-calendar-button";
// import Vue from "vue";

export default {
    name: "UpcomingTicketCard",
    data() {
        return {
            size: 0,
            open: false,
            eventImage: "",
        };
    },
    head() {
        return {
            // script: [
            //     {
            //         src: "https://cdn.jsdelivr.net/npm/add-to-calendar-button@2t",
            //         async: true,
            //         defer: true,
            //     },
            // ],
        };
    },

    props: {
        mobile: {
            type: Boolean,
            default: true,
        },
        scannable: {
            type: Boolean,
            default: false,
        },
        clear: {
            type: Function,
            default: () => {},
        },

        error: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
        ticket: {
            type: Object,
            default: () => {
                return {
                    orderID: "",
                    id: "",
                    orderId: "",
                    payerId: "",
                    paymentId: "",
                    paymentSource: "",
                    updatedAt: "",
                    createdAt: "",
                    amount: "",
                    quantity: "",
                    link: "",
                    title: "",
                    currency: "",
                    status: "",
                    user: "",
                    membership: "",
                    event: "",
                };
            },
        },
    },
    mounted() {
        // this.mountAddToCalButton();
        this.$nextTick(function () {
            this.onResize();
        });
        if (this.ticket.event.image) {
            // image is a cloudinary url in the form https://res.cloudinary.com/CLOUDINARY_ID/image/upload/VERSION/events/IMAGE_ID.webp

            const imageId = this.ticket.event.image
                .split("/")
                .pop()
                .split(".")[0];
            const cloudinaryId = "dwiebcqwl";
            this.eventImage = `https://res.cloudinary.com/${cloudinaryId}/image/upload/c_scale,f_auto,w_300/events/${imageId}.webp`;
        }
        window.addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        getScreenSize() {
            const width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;

            return width;
        },
        onResize() {
            this.size = this.getScreenSize();
        },
    },
};
</script>
